export default __webpack_public_path__ + "static/media/conventional-commits.55fdad3c.md";